import { z } from 'zod'

import { PackageStatusSchema } from '@/models'

// Note: Extend possible statuses to include 'all' which will be only indicated in UI
export const PackageStatusExtendedEnum = z.enum([...PackageStatusSchema.options, 'All'])
export type PackageStatusExtended = z.infer<typeof PackageStatusExtendedEnum>
